import { Link, useLocation } from "react-router-dom";
import { Home, ShoppingBag, BookOpen, MessageCircle } from "lucide-react";

export const MobileNav = () => {
  const location = useLocation();

  const navItems = [
    { name: "Home", path: "/", icon: Home },
    { name: "Shop", path: "/shop", icon: ShoppingBag },
    { name: "Blog", path: "/blog", icon: BookOpen },
    { name: "Contact", path: "/contact", icon: MessageCircle },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone-200 shadow-lg">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`mobile-bottom-nav-${item.name.toLowerCase()}`}
              className={`mobile-nav-item flex flex-col items-center gap-1 px-4 py-2 transition-colors ${
                active ? "active text-deep-moss" : "text-stone-500"
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 1.5} />
              <span className="text-xs font-sans">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
